import {useNavigate, useSearchParams} from "react-router-dom";
import {serviceEventTicketPolicySelector, useGetServiceEventTicketPolicyQuery} from "@ots-frontend/ots-data";
import {skipToken} from "@reduxjs/toolkit/query";
import {useMemo, useState} from "react";
import {useTranslation} from "react-i18next";
import {ErrorPage} from "../../components/page/ErrorPage/ErrorPage";
import {
  ServiceEventTicketPolicyProfile
} from "../../components/profile/ServiceEventTicketPolicyProfile/ServiceEventTicketPolicyProfile";
import {EntityProfilePage} from "../EntityProfilePage/EntityProfilePage";

type Props = {
  id?: string;
}

export const ServiceEventTicketPolicyProfilePageRoute = () => {
  const [params, _setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const {t} = useTranslation()

  const id = params.get("id") ?? undefined;

  if (!id) {
    navigate(-1);
    return (
      <ErrorPage
        message={t("common.entity.serviceeventticketpolicy", "Service Event Ticket Policy") + " " + t("common.error.notfound", "Not Found")}/>
    );
  }

  return <ServiceEventTicketPolicyProfilePage id={id}/>;
};

export const ServiceEventTicketPolicyProfilePage = (props: Props) => {
  const {id} = props;

  const [access, setAccess] = useState(false);

  const selectServiceEventTicketPolicy = useMemo(() => {
    return serviceEventTicketPolicySelector()
  }, []);

  const {serviceEvent, isFetching} = useGetServiceEventTicketPolicyQuery(access ? (id ?? skipToken) : skipToken, {
    selectFromResult: (result) => ({
      serviceEvent: selectServiceEventTicketPolicy(result),
      isFetching: result.isFetching
    })
  });

  return (
    <EntityProfilePage
      permissions={["serviceeventticketpolicy_view"]}
      entity={serviceEvent}
      isLoading={isFetching}
      onAccess={setAccess}>
      {(entity) => (
        <ServiceEventTicketPolicyProfile policy={entity}/>
      )}
    </EntityProfilePage>
  )
};
